import {Box, styled} from "@mui/material";
import React from "react";
import {AISummaryContainer} from "../AI/AISummary";
import {Title} from "../Contacts/Contacts";
import useCasesScenariosBackground from "../../assets/useCasesScenariosBackground.png";

const UseCasesScenariosContainer = styled(Box)({
    background: `linear-gradient(rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.5)), url(${useCasesScenariosBackground}) no-repeat center / cover`,
});

const UseCasesScenariosContentBox = styled(AISummaryContainer)({
    background: "transparent"
});

const UseCasesScenarios = ():JSX.Element => {
    return <UseCasesScenariosContainer id={"userscenarios"}>
        <Title>
            User Scenarios:
        </Title>
        <UseCasesScenariosContentBox>
            <ul>
                <li>
                    Regular Users (Individual Investors):
                    <ul>
                        <li>
                            <b>Personalized Analytics:</b> Leveraging AI to analyze financial goals and market conditions, providing users with detailed insights into potential market movements and trends.
                        </li>
                        <li>
                            <b>Market Forecasts:</b> AI-powered forecasts that help users understand future market scenarios, aiding in their financial planning without direct recommendations.
                        </li>
                        <li>
                            <b>Automated Alerts:</b> Notifications about significant predicted market changes relevant to their financial interests, facilitating informed decision-making.
                        </li>
                    </ul>
                </li>
                <li>
                    Professional Traders:
                    <ul>
                        <li>
                            <b>Real-Time Market Analysis:</b> Access to sophisticated analysis tools that deliver comprehensive insights and forecasts about market trends.
                        </li>
                        <li>
                            <b>Trading Signals:</b> AI-generated signals based on predictive market behaviors, supporting traders in strategizing their trades more effectively.
                        </li>
                        <li>
                            <b>Risk Management Tools:</b> Advanced tools for assessing and managing potential risks identified through AI-driven market forecasts.
                        </li>
                    </ul>
                </li>
                <li>
                    Casual Savers:
                    <ul>
                        <li>
                            <b>Savings Insights:</b> Automated insights based on AI forecasts, suggesting optimal times for saving based on predicted financial trends and personal spending patterns.
                        </li>
                        <li>
                            <b>Investment Insights for Beginners:</b> Data-driven insights into potential market movements, helping users understand when might be a better time to invest or save.
                        </li>
                        <li>
                            <b>Progress Monitoring:</b> Tools that visualize financial growth, influenced by AI predictions on market conditions and personal finance trends.
                        </li>
                    </ul>
                </li>
            </ul>
            <ul>
                <li>
                    Business Clients (SMEs):
                    <ul>
                        <li>
                            <b>Tailored Financial Analysis:</b> Custom analytics that incorporate AI forecasts of market conditions, tailored to specific business needs and industry trends.
                        </li>
                        <li>
                            <b>Cash Flow Predictions:</b> Predictive analytics for cash flow, providing businesses with foresight into financial planning and management.
                        </li>
                        <li>
                            <b>Investment Strategy Support:</b> Support tools that use AI-generated market forecasts to help align business investment actions with expected market developments.
                        </li>
                    </ul>
                </li>
                <li>
                    Hedge Funds:
                    <ul>
                        <li>
                            <b>Advanced Portfolio Analysis:</b> Comprehensive analytics including detailed forecasts of market trends that impact various investment strategies.
                        </li>
                        <li>
                            <b>Algorithmic Trading Support:</b> Algorithms that utilize AI-generated forecasts to automate trading decisions based on predicted market shifts.
                        </li>
                        <li>
                            <b>Compliance Monitoring:</b> Ensuring adherence to financial regulations with tools that incorporate future regulatory changes predicted by AI.
                        </li>
                    </ul>
                </li>
                <li>
                    Financial Startups:
                    <ul>
                        <li>
                            <b>Scenario:</b> Emerging fintech companies leverage our AI technology to enhance and expand their financial service offerings.
                        </li>
                        <li>
                            <b>AI Application:</b> By integrating our AI, startups gain access to comprehensive analytics, powering their services with advanced insights and improved decision-making capabilities.
                        </li>
                        <li>
                            <b>Usability Highlight:</b> Our platform’s API-first design ensures seamless integration, allowing startups to efficiently implement sophisticated features and scale their operations with minimal technical overhead.
                        </li>
                    </ul>
                </li>
            </ul>
        </UseCasesScenariosContentBox>
    </UseCasesScenariosContainer>;
    
};

export default UseCasesScenarios;
